import { BrowserRouter, Routes, Route } from "react-router-dom"
import Navbar from "./components/nav"
import Hero from "./components/hero"
import Sidebar from "./components/side"
import How from "./components/how"
import Privacy from "./components/privacy"

const App = () => {
  return (
    <BrowserRouter>
      <main className="flex flex-col lg:flex-row lg:h-screen overflow-auto">
        <section className="gradient__bg flex flex-col gap-24 lg:gap-48 sticky lg:w-1/2">
          <Navbar />
          <Hero />
        </section>
        <Routes>
          <Route path="/" element={<Sidebar />} />
          <Route path="/business" element={<How />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </main>
    </BrowserRouter>
  )
}

export default App